import styled from 'styled-components';
import { red600 } from 'material-ui/styles/colors';

const ErrorMessage = styled.p`
  color: ${red600};
  font-size: ${props => (props.fontSize ? `${props.fontSize}px` : '13px')};
`;

export default ErrorMessage;
